export default {
  messages: {
    en: {
      activity: 'Activity type:',
      amount: 'Amount requested:',
      mfi: 'Partner:',
      term: 'Repayment term:',
      termValue: '{num} months',
    },
  },
}
